export enum OfferNetworkProvider {
  Falcon = "falcon",
  Rokt = "rokt",
  Uptick = "uptick",
}
